<!-- App.vue -->
<template>
  <div id="app">
    <router-view></router-view> <!-- 這裡顯示匹配的路由組件 -->
  </div>
</template>